import axios from 'axios'
import { ParticipantData } from '../screen/TKG_RESERVE_0210/TKG_RESERVE_0210';

// バックエンド側のエスケープを解除する関数
const unescapeBackendData = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    return obj.replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t');
  }

  if (Array.isArray(obj)) {
    return obj.map(item => unescapeBackendData(item));
  }

  if (typeof obj === 'object') {
    const unescapedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        unescapedObj[key] = unescapeBackendData(obj[key]);
      }
    }
    return unescapedObj;
  }

  return obj;
};

// ====================================================
// サーバーサイドとのやりとりで必要な共通設定
// ====================================================
const allowOriginList = [ "http://tkg-reserve.com", "https://tkg-reserve.com", "http://www.tkg-reserve.com", "https://www.tkg-reserve.com", "http://localhost:8080", "https://localhost:8080" ]
const allowOriginListDev = [ "http://localhost:3000", "https://localhost:3000" ]
if (allowOriginList.includes(window.location.origin)) {
  axios.defaults.baseURL = window.location.origin + ':8443/TKG_Reserve/';
} else if (allowOriginListDev.includes(window.location.origin)) {
  axios.defaults.baseURL = 'http://localhost:8080/TKG_Reserve/';
}
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
axios.defaults.withCredentials = true;

// ====================================================
// サーバーサイドのAPIを実行する関数群
// ====================================================
/**
 * 【TKG_RESERVE_0100】ログイン画面
 * LINEログイン認証を実行する
 *
 * @returns ログイン用のURL
 */
export const authLineLogin = async (authorizationCode: any) => {
  const body = {
    authorization_code: authorizationCode
  }
  const res = await axios.post('login', body);
  console.log(res);
  let data = res != null ? res.data : null

  // JSONが文字列として返された場合のフォールバック処理
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      console.error('Failed to parse response data as JSON', e);
      throw e;
    }
  }

  data = unescapeBackendData(data);

  const result = {
    userId: data.userId,
    displayName: data.displayName,
    statusMessage: data.statusMessage,
    pictureUrl: data.pictureUrl,
    isRegistered: data.isRegistered
  }
  console.log("LOGIN_API_001結果：", result);
  return result;
}

/**
 * 【TKG_RESERVE_0100】ログイン画面
 * ユーザーマスタ登録を実行する
 *
 * @returns ログイン用のURL
 */
export const register = async (user_id: string, user_name: string, picture_url: string) => {
  const body = {
    user_id: user_id,
    user_name: user_name,
    picture_url: picture_url
  }
  const res = await axios.post('login/register', body);
  var data = res != null ? res.data : null
  console.log("LOGIN_API_002結果：", data);
  return data;
}

/**
 * 【TKG_RESERVE_0100】ログイン画面
 * LINEログイン用URLを取得する
 *
 * @returns ログイン用のURL
 */
export const getLoginUrl = async () => {
  const res = await axios.get('login/url');
  var data = res != null ? res.data : null
  console.log("LOGIN_API_003結果：", data);
  return data;
}

/**
 *  【TKG_RESERVE_0120】ポータル画面
 * ポータル画面の情報を取得する処理
 *
 * @param user_id ユーザーID
 * @returns ポータル画面の情報
 */
export const getEvents = async (user_id: string) => {
  const body = {
    user_id: user_id
  };

  const response = await axios.post('portal/initialize', body, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  response.data = unescapeBackendData(response.data);
  console.log("PORTAL_API_001結果：", response);
  return response;
}

/**
 * 【TKG_RESERVE_0130】イベント詳細画面
 * イベント詳細情報を取得する処理
 *
 * @returns イベント詳細情報
 */
export const getEventDetails = async (userId: string, eventId: string) => {
  const body = {
    user_id: userId,
    event_id: eventId
  };
  const res = await axios.post('event/initialize', body);
  var data = res != null ? res.data : null
  data = unescapeBackendData(data);
  console.log("EVENT_API_001結果：", data);
  return data;
}

/**
 * 【TKG_RESERVE_0130】イベント詳細画面
 * 予約申請処理
 *
 * @returns 予約申請結果
 */
export const reserveApply = async (requestData: object) => {
  // 【EVENT_API_002】にリクエストを送信
  console.log("予約処理(リクエスト)：", requestData);

  // validateStatus を設定して、すべてのレスポンスを「エラーとして扱わない」ようにする
  const response = await axios.post('event/reserve', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_API_002結果：", response);
  return response;
}

/**
 * 【TKG_RESERVE_0130】イベント詳細画面
 * キャンセル申請処理
 *
 * @returns キャンセル申請結果
 */
export const cancelApply = async (userId: string, eventId: string, cancelTarget: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "event_id" : eventId,
    "cancelCls" : cancelTarget
  }

  // 【EVENT_API_003】にリクエストを送信
  console.log("キャンセル処理(リクエスト)：", requestData);

  // validateStatus を設定して、すべてのレスポンスを「エラーとして扱わない」ようにする
  const response = await axios.post('event/cancel', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_API_003結果：", response);
  return response;
}
// EVENT_API_004

/**
 * 【TKG_RESERVE_0130】イベント詳細画面
 * 飲み会当日参加申請処理
 *
 * @returns 飲み会当日参加申請結果
 */
export const todayDrinkApply = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "event_id" : eventId
  }

  // 【EVENT_API_004】にリクエストを送信
  console.log("飲み会当日参加処理(リクエスト)：", requestData);

  // validateStatus を設定して、すべてのレスポンスを「エラーとして扱わない」ようにする
  const response = await axios.post('event/todayDrinkApply', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_API_004結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0200】管理者ポータル画面
 * 初期表示処理
 *
 * @returns 初期表示結果
 */
export const managerPortalInitialize = async (userId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
  }

  // 【EVENT_M_API_003】にリクエストを送信
  const response = await axios.post('mng/portal/initialize', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  response.data = unescapeBackendData(response.data);
  console.log("PORTAL_M_API_001結果：", response.data);
  return response;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 初期表示処理
 *
 * @returns 初期表示結果
 */
export const eventManagementInitialize = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "event_id" : eventId
  }

  // 【EVENT_M_API_001】にリクエストを送信
  const response = await axios.post('mng/event/initialize', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  const data = unescapeBackendData(response.data);
  console.log("EVENT_M_API_001結果：", data);
  return data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 更新処理
 *
 * @returns 処理結果
 */
export const updateEvent = async (userId: string, eventId: string, data: any) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "event_id" : eventId,
    "event_name" : data.event_name,
    "b_start_time" : data.b_start_time,
    "b_end_time" : data.b_end_time,
    "d_start_time" : data.d_start_time,
    "d_end_time" : data.d_end_time,
    "b_entry_fee" : data.b_entry_fee,
    "d_entry_fee" : data.d_entry_fee,
    "arena_id" : data.arena_id,
    "restaurant" : data.restaurant,
    "restaurant_url" : data.restaurant_url,
    "question_content" : data.question_content,
    "event_content" : data.event_content,
    "belongings" : data.belongings,
    "notes" : data.notes,
    "memo" : data.memo,
    "meeting_time" : data.meeting_time,
    "capacity_num" : data.capacity_num,
    "man_capacity_num" : data.man_capacity_num,
    "woman_capacity_num" : data.woman_capacity_num
  }

  // 【EVENT_M_API_002】にリクエストを送信
  const response = await axios.post('mng/event/update', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_002結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 公開・非公開切り替え
 *
 * @returns 処理結果
 */
export const changePublic = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "event_id" : eventId
  }

  // 【EVENT_M_API_005】にリクエストを送信
  const response = await axios.post('mng/event/change_public', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_005結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 承認
 *
 * @returns 処理結果
 */
export const approval = async (userId: string, targetUserId: string, eventId: string, message: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "target_user_id" : targetUserId,
    "event_id" : eventId,
    "message" : message
  }

  // 【EVENT_M_API_006】にリクエストを送信
  const response = await axios.post('mng/event/approval', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_006結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 否認
 *
 * @returns 処理結果
 */
export const deny = async (userId: string, targetUserId: string, eventId: string, message: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "target_user_id" : targetUserId,
    "event_id" : eventId,
    "message" : message
  }

  // 【EVENT_M_API_007】にリクエストを送信
  const response = await axios.post('mng/event/deny', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_007結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 参加者削除
 *
 * @returns 処理結果
 */
export const deleteParticipant = async (userId: string, selectedUserIdList: string[], eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "target_user_id_list" : selectedUserIdList,
    "event_id" : eventId
  }

  // 【EVENT_M_API_008】にリクエストを送信
  const response = await axios.post('mng/event/delete', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_008結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 参加者追加
 *
 * @returns 処理結果
 */
export const registParticipant = async (userId: string, event_id: string, data: ParticipantData) => {
  const requestData = {
    "user_id" : userId,
    "event_id" : event_id,
    "user_name": data.user_name,
    "sex": data.sex.getCode(),
    "age": data.age,
    "b_participation_flag": data.b_participation_flag.code,
    "d_participation_flag": data.d_participation_flag.code,
    "reserve_status": data.reserve_status.getCode(),
    "question_answer": data.question_answer
  }

  // 【EVENT_M_API_006】にリクエストを送信
  console.log("参加者追加処理(リクエスト)：", requestData);
  const response = await axios.post('mng/event/registParticipant', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_016結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * CSVダウンロード
 *
 * @returns 処理結果
 */
export const csvDownload = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    user_id: userId,
    event_id: eventId,
  };

  try {
    // サーバーにPOSTリクエストを送信
    const response = await axios.post("mng/event/csvDownload", requestData, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json", 
      },
      validateStatus: () => true,
    });

    // ステータスコードを確認
    if (response.status === 200) {
      // Blobを作成
      const blob = new Blob([response.data], { type: "text/csv" });

      // 現在の日付を取得してフォーマット
      const now = new Date();
      const yyyy = now.getFullYear();
      const MM = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const formattedDate = `${yyyy}${MM}${dd}`;

      // ファイル名を設定
      const fileName = `${eventId}_${formattedDate}.csv`;

      // ブラウザからダウンロード
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("ダウンロード失敗", response.status);
    }
  } catch (error) {
    console.error("CSVダウンロード中にエラーが発生しました:", error);
  }
};

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * チーム表ダウンロード
 *
 * @returns 処理結果
 */
export const teamDownload = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    user_id: userId,
    event_id: eventId,
  };

  try {
    // サーバーにPOSTリクエストを送信
    const response = await axios.post("mng/event/teamDownload", requestData, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json", 
      },
      validateStatus: () => true,
    });

    // ステータスコードを確認
    if (response.status === 200) {
      // Blobを作成
      const blob = new Blob([response.data], { type: "text/csv" });

      // 現在の日付を取得してフォーマット
      const now = new Date();
      const yyyy = now.getFullYear();
      const MM = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const formattedDate = `${yyyy}${MM}${dd}`;

      // ファイル名を設定
      const fileName = `チーム分け_${eventId}_${formattedDate}.csv`;

      // ブラウザからダウンロード
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("ダウンロード失敗", response.status);
    }
  } catch (error) {
    console.error("チーム表ダウンロード中にエラーが発生しました:", error);
  }
};

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 収支登録
 *
 * @returns 処理結果
 */
export const paymentRegister = async (requestData: any) => {
  // 【EVENT_M_API_011】にリクエストを送信
  const response = await axios.post('mng/event/paymentRegister', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });
  console.log("EVENT_M_API_011結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * イベント削除
 *
 * @returns 処理結果
 */
export const eventDelete = async (userId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    user_id: userId,
    event_id: eventId
  };

  // 【EVENT_M_API_012】にリクエストを送信
  const response = await axios.post('mng/event/eventDelete', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });
  console.log("EVENT_M_API_012結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * メッセージ配信
 *
 * @returns 処理結果
 */
export const publishMessage = async (userId: string, message: string) => {
  // リクエストデータを作成
  const requestData = {
    user_id: userId,
    message: message
  };

  // 【EVENT_M_API_013】にリクエストを送信
  console.log("EVENT_M_API_013入力：", requestData);
  const response = await axios.post('mng/event/publishMessage', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });
  console.log("EVENT_M_API_013結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 繰り上がり通知
 *
 * @returns 処理結果
 */
export const advanceNotice = async (userId: string, targetUserId: string, eventId: string, message: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "target_user_id" : targetUserId,
    "event_id" : eventId,
    "message" : message
  }

  // 【EVENT_M_API_014】にリクエストを送信
  console.log("EVENT_M_API_014入力：", requestData);
  const response = await axios.post('mng/event/advanceNotice', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });
  console.log("EVENT_M_API_014結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 飲み会当日参加承認
 *
 * @returns 処理結果
 */
export const todayDrinkApproval = async (userId: string, targetUserId: string, eventId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
    "target_user_id" : targetUserId,
    "event_id" : eventId
  }

  // 【EVENT_M_API_015】にリクエストを送信
  console.log("EVENT_M_API_015入力：", requestData);
  const response = await axios.post('mng/event/todayDrinkApproval', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });
  console.log("EVENT_M_API_015結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0220】ユーザー管理画面
 * 初期表示処理
 *
 * @returns 初期表示結果
 */
export const userManagerInitialize = async (userId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
  }

  // 【USER_M_API_001】にリクエストを送信
  const response = await axios.post('mng/user/initialize', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  const data = unescapeBackendData(response.data);
  console.log("USER_M_API_001結果：", data);
  return data;
}

/**
 * 【TKG_RESERVE_0220】ユーザー管理画面
 * ユーザー更新
 *
 * @returns 処理結果
 */
export const userUpdate = async (data: any) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : data.user_id,
    "target_user_id" : data.target_user_id,
    "user_name" : data.user_name,
    "role" : data.role,
    "valid_flag" : data.valid_flag,
    "sex" : data.sex,
    "birthday" : data.birthday,
    "paypay_name" : data.paypay_name,
    "paypay_id" : data.paypay_id
  }

  // 【USER_M_API_002】にリクエストを送信
  const response = await axios.post('mng/user/update', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("USER_M_API_002結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0220】ユーザー管理画面
 * メッセージ送信
 *
 * @returns 処理結果
 */
export const sendMessage = async (requestData: any) => {
  const response = await axios.post('mng/user/sendMessage', requestData, {
    validateStatus: () => true,
  });
  console.log("USER_M_API_003結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0230】体育館管理画面
 * 初期表示処理
 *
 * @returns 初期表示結果
 */
export const arenaManagerInitialize = async (userId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
  }

  // 【ARENA_M_API_001】にリクエストを送信
  const response = await axios.post('mng/arena/initialize', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  const data = unescapeBackendData(response.data);
  console.log("ARENA_M_API_001結果：", data);
  return data;
}

/**
 * 【TKG_RESERVE_0230】ユーザー管理画面
 * 体育館更新
 *
 * @returns 処理結果
 */
export const arenaUpdate = async (data: any) => {
  // リクエストデータを作成
  const requestData = {
    user_id: data.user_id,
    arena_id: data.arena_id,
    arena_name: data.arena_name,
    arena_address: data.arena_address,
    arena_url: data.arena_url,
    meeting_place: data.meeting_place,
    facility: data.facility
  }

  // 【ARENA_M_API_002】にリクエストを送信
  const response = await axios.post('mng/arena/update', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("ARENA_M_API_002結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0230】ユーザー管理画面
 * 体育館登録
 *
 * @returns 処理結果
 */
export const arenaRegister = async (data: any) => {
  // リクエストデータを作成
  const requestData = {
    user_id: data.user_id,
    arena_name: data.arena_name,
    arena_address: data.arena_address,
    arena_url: data.arena_url,
    meeting_place: data.meeting_place,
    facility: data.facility,
    isEditing: false
  }

  // 【ARENA_M_API_003】にリクエストを送信
  const response = await axios.post('mng/arena/register', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("ARENA_M_API_003結果：", response.data);
  return response.data;
}

/**
 * 【TKG_RESERVE_0240】イベント新規登録画面
 * 初期表示処理
 *
 * @returns 初期表示結果
 */
export const eventRegisterInitialize = async (userId: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id" : userId,
  }

  // 【EVENT_M_API_003】にリクエストを送信
  const response = await axios.post('mng/event/register/initialize', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  const data = unescapeBackendData(response.data);
  console.log("EVENT_M_API_003結果：", data.arenaList);
  return data.arenaList;
}

/**
 * 【TKG_RESERVE_0240】イベント新規登録画面
 * イベント新規登録処理
 *
 * @returns イベント新規登録結果
 */
export const eventRegister = async (formData: object) => {
  // 【EVENT_M_API_004】にリクエストを送信
  const response = await axios.post('mng/event/register', formData, {
    validateStatus: () => true,
  });

  console.log("EVENT_M_API_004結果：", response);
  return response;
}

/**
 * 【TKG_RESERVE_0210】イベント管理画面
 * 参加者情報更新
 *
 * @returns 処理結果
 */
export const updateParticipants = async (userId: string, targetUserId: string, eventId: string, reserveStatus: string) => {
  // リクエストデータを作成
  const requestData = {
    "user_id": userId,
    "target_user_id": targetUserId,
    "event_id": eventId,
    "reserve_status": reserveStatus,
  };

  // 【EVENT_M_API_017】にリクエストを送信
  const response = await axios.post('mng/event/updateStatus', requestData, {
    validateStatus: () => true, // すべてのステータスコードを許可
  });

  console.log("EVENT_M_API_017結果：", response.data);
  return response.data;
};
